var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{style:({ 'background-image': 'url(' + _vm.image + ')' }),attrs:{"id":"loginImage","align-start":"","justify-center":"","fill-height":"","layout":"column"}},[_c('img',{attrs:{"id":"loginLogo","src":_vm.logo}})])
}
var staticRenderFns = []

export { render, staticRenderFns }